import React, { useState, useEffect,useMemo  } from "react";
import vector from "../assets/icons/icon-vector.svg";
import vclose from "../assets/icons/icon-vclose.svg";
import closevector from "../assets/icons/icon-closevector.svg";
import rotate from "../assets/icons/angle-svgrepo-com.svg";
import { useSelector, useDispatch } from "react-redux";
import reset from "../assets/icons/icon-reset.svg";
import { saveState } from "../Store/reducers/fabriccontrolsSlice";
import { setFabricCanvasAsImage } from "../Store/reducers/svgSlice.jsx";
import { convertFabricCanvasToPNGDataURL } from "../utils/fabricHelper.js";
import { updateObjectProperty } from "../Store/reducers/pixiObjectPropertiesSlice.js";
import { useLocation } from "react-router-dom";
import AlignmentControls from "./Rightpanel subcomponents/AlignmentControls.jsx";
import debounce from "lodash/debounce";

const RightPanel = () => {
  const fabricCanvas = useSelector((state) => state.fabricCanvas.fabricCanvas);
  const pixiCanvas = useSelector((state) => state.canvas.app);
  const activeTab = useSelector((state) => state.activeTab.activeTab);
  const pixiActiveObject = useSelector((state) => state.canvas.activeObject);
  const withoutObject = useSelector((state) => state.canvas.object);
   const canvasesState = useSelector((state) => state.canvasesstate.canvases);
  const selectedMockup = useSelector((state) => state.mockupCategories.selectedMockup) || [];

  const dispatch = useDispatch();


  const [isOpen, setIsOpen] = useState(false);
  const [color, setColor] = useState("#4E76FB");
  const [showImages, setShowImages] = useState(false);
  const [showEditOptions, setShowEditOptions] = useState(true);
  const [opacity, setOpacity] = useState(100);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [size, setSize] = useState({ width: 0, height: 0 });
  const [angle, setAngle] = useState(0);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const productId = queryParams.get("product_id");

  const savedState = JSON.parse(
    canvasesState.previewMockupCanvasState?.currentState
  );
  // const [wrap, setWrap] = useState(savedState?.wrapping || 15);
  const [wrap, setWrap] = useState(savedState?.textDesign?.wrapping ? savedState.textDesign.wrapping * 2 : 15);
  const timeoutDuration = 500;


  useEffect(() => {
    if (pixiActiveObject && pixiCanvas) {
      const initialOpacity = pixiActiveObject.alpha * 100;
      
      const initialPosition = { x: pixiActiveObject.x, y: pixiActiveObject.y };
      const initialSize = {
        width: pixiActiveObject.width,
        height: pixiActiveObject.height,
      };
      const initialAngle = pixiActiveObject.rotation * (180 / Math.PI);

      setOpacity(initialOpacity);
      setPosition(initialPosition);
      setSize(initialSize);
      setAngle(initialAngle);
      console.log("updated prop", {
        opacity: initialOpacity,
        x: initialPosition.x,
        y: initialPosition.y,
        width: initialSize.width,
        height: initialSize.height,
        rotation: pixiActiveObject.rotation,
      })
      dispatch(
        updateObjectProperty({
          opacity: initialOpacity,
          x: initialPosition.x,
          y: initialPosition.y,
          width: initialSize.width,
          height: initialSize.height,
          rotation: pixiActiveObject.rotation,
        })
      );
    }
  }, [pixiActiveObject, dispatch]);

  const handleChange = (property, e, axis) => {
    const inputVal = e.target.value;
    let fabricObject = fabricCanvas && fabricCanvas?.getActiveObject();
    if ((pixiActiveObject && activeTab ==="previewMockup" ) || ( withoutObject  && activeTab ==="previewMockup" )) {
      switch (property) {
        case "opacity":
          setOpacity(inputVal);
          withoutObject.alpha = inputVal / 100;
          dispatch(
            updateObjectProperty({
              opacity: withoutObject.alpha * 100,
            })
          );
          break;
        case "angle":
          setAngle(inputVal);
          pixiActiveObject.rotation = inputVal * (Math.PI / 180);
          dispatch(
            updateObjectProperty({ rotation: pixiActiveObject.rotation })
          );
          break;
        case "position":
          const posValue = parseFloat(inputVal) || 0;
          setPosition({ ...position, [axis]: posValue });
          if (axis === "x") {
            pixiActiveObject.x = posValue;
          } else {
            pixiActiveObject.y = posValue;
          }
          dispatch(
            updateObjectProperty({
              x: pixiActiveObject.x,
              y: pixiActiveObject.y,
            })
          );
          break;
        case "size":
          const sizeValue = parseFloat(inputVal) || 0;
          setSize({ ...size, [axis]: sizeValue });
          if (axis === "width") {
            pixiActiveObject.width = sizeValue;
          } else {
            pixiActiveObject.height = sizeValue;
          }
          dispatch(
            updateObjectProperty({
              width: pixiActiveObject.width,
              height: pixiActiveObject.height,
            })
          );
          break;
        default:
          break;
      }
    } else if (fabricObject &&  ["editSVG","editMockup"].includes(activeTab) ) {
      switch (property) {
        case "opacity":
          setOpacity(inputVal);
          fabricObject.set("opacity", inputVal / 100);
          fabricCanvas.renderAll();
          saveCanvasState();
          break;
        case "angle":
          setAngle(inputVal);
          fabricObject.set({
            angle: inputVal,
            originX: "center",
            originY: "center",
            left: fabricObject.left,
            top: fabricObject.top,
          });
          fabricCanvas.renderAll();
          saveCanvasState();
          break;
        case "position":
          const posValue = parseFloat(inputVal) || 0;
          setPosition({ ...position, [axis]: posValue });
          fabricObject.set(axis === "x" ? "left" : "top", posValue);
          fabricCanvas.renderAll();
          saveCanvasState();
          break;
        case "size":
          const sizeValue = parseFloat(inputVal) || 0;
          setSize({ ...size, [axis]: sizeValue });
          const scale =
            axis === "width"
              ? sizeValue / fabricObject.width
              : sizeValue / fabricObject.height;
          fabricObject.set(axis === "width" ? "scaleX" : "scaleY", scale);
          fabricCanvas.renderAll();
          saveCanvasState();
          break;
        default:
          break;
      }
    }
  };

  
  useEffect(() => {
    if (activeTab === "previewMockup" && withoutObject && withoutObject.filters && withoutObject.filters[0]) {
      withoutObject.filters[0].scale.x = wrap / 2;
      withoutObject.filters[0].scale.y = wrap / 2;
  
      withoutObject.filters[0].padding = 30; 
      withoutObject.filters[0].autoFit = true;
  
      if (withoutObject.updateTransform) {
        withoutObject.updateTransform();
      }
  
      if (withoutObject._filters) {
        withoutObject._filters.forEach((filter) => {
          if (filter.apply) {
            filter.apply(filter);
          }
        });
      }
  
      
      if (pixiCanvas && pixiCanvas.renderer) {
        pixiCanvas.render(); 
      }
    }
  }, [wrap, activeTab, withoutObject]);


  const handleWrapChange = (value) => {
  
    if (withoutObject) {
      
      withoutObject.filters[0].scale.x = value/2;
      withoutObject.filters[0].scale.y = value/2;
      
      let currentState = canvasesState.previewMockupCanvasState?.currentState;
      
             
      
      if (currentState) {
        try {
          currentState = JSON.parse(currentState);
        } catch (err) {
          currentState = {};
        }
      } else {
        currentState = {};
      }
      if (!currentState.textDesign) {
        currentState.textDesign = {};
      }
      currentState.textDesign.wrapping = value/2;
      
      dispatch(saveState({ tab: "previewMockupCanvasState", canvasState: JSON.stringify(currentState) }));
    }
    
    setWrap(value);
  };
  

  const wrapBackground = `linear-gradient(to right, #4e76f8 ${wrap}%, #ddd ${wrap}%)`;

  useEffect(() => {
    if (fabricCanvas) {
      const handleSelection = () => {
        const activeObject = fabricCanvas.getActiveObject();
        if (activeObject) {
          setIsOpen(true);
          setShowEditOptions(false);
          setColor(activeObject.fill || "#000000");
          setOpacity(activeObject.opacity ? activeObject.opacity * 100 : 100);
          setPosition({
            x: activeObject.left || 0,
            y: activeObject.top || 0,
          });
          setSize({
            width: activeObject.width * activeObject.scaleX || 0,
            height: activeObject.height * activeObject.scaleY || 0,
          });
          setAngle(activeObject.angle || 0);
        } else {
          setIsOpen(false);
        }
      };

      const handleDeselection = () => {
        if (fabricCanvas._isGrouping) return;
        setIsOpen(false);
        setTimeout(() => {
          setShowEditOptions(true);
        }, timeoutDuration);
      };

      fabricCanvas.on("selection:created", handleSelection);
      fabricCanvas.on("selection:updated", handleSelection);
      fabricCanvas.on("object:modified", handleSelection);
      fabricCanvas.on("selection:cleared", handleDeselection);

      return () => {
        fabricCanvas.off("selection:created", handleSelection);
        fabricCanvas.off("selection:updated", handleSelection);
        fabricCanvas.off("object:modified", handleSelection);
        fabricCanvas.off("selection:cleared", handleDeselection);
      };
    }
  }, [fabricCanvas]);

  useEffect(() => {
    if (pixiCanvas && pixiActiveObject) {
      setOpacity(pixiActiveObject.alpha ? pixiActiveObject.alpha * 100 : 100);
    }
  }, [pixiCanvas, pixiActiveObject]);

  const debouncedSaveCanvas = useMemo(
    () =>
      debounce(() => {
        saveCanvasState();
      }, 300),
    [fabricCanvas] 
  );

  const handleColorChange = (e) => {
    const newColor = e.target.value;
    setColor(newColor);
    const activeObject = fabricCanvas.getActiveObject();

    if (activeObject) {
      if (activeObject.type === "textbox" || activeObject.type === "text") {
        activeObject.set("fill", newColor);
      } else if (activeObject.type === "group") {
        activeObject.forEachObject((obj) => {
          if (
            obj.type === "path" ||
            obj.type === "rect" ||
            obj.type === "circle"
          ) {
            obj.set({
              fill: newColor,
              dirty: true,
            });
          } else if (obj.type === "textbox" || obj.type === "text") {
            obj.set({
              fill: newColor,
              dirty: true,
            });
          }
        });
        activeObject.setCoords();
      } else {
        activeObject.set({
          fill: newColor,
          // stroke: newColor
        });
      }

      fabricCanvas.renderAll();
       debouncedSaveCanvas();
    }
  };

  const sliderBackground = `linear-gradient(to right, #4e76f8 ${opacity}%, #ddd ${opacity}%)`;

  const saveCanvasState = () => {
    const canvasState = JSON.stringify(fabricCanvas.toJSON(["protected"]));
    dispatch(saveState({ tab: `${activeTab}CanvasState`, canvasState }));
    // localStorage.setItem(`${activeTab}CanvasState_${productId}`, canvasState); 
    // dispatch(saveState(canvasState));
    if (activeTab === "editSVG") {
      const canvasJSON = JSON.stringify(fabricCanvas.toJSON(["protected"]));
      const canvasSVGDataURL = convertFabricCanvasToPNGDataURL(fabricCanvas);
      // const currentState = JSON.parse(
      //   localStorage.getItem(`pixiCanvasState_${productId}`)
      // );
    
      const currentState = canvasesState.previewMockupCanvasState?.currentState
      ? JSON.parse(canvasesState.previewMockupCanvasState.currentState)
      : {};
    
      const updatedState = {
        ...currentState,
        canvasState: canvasJSON,
      };
      dispatch(saveState({ tab: "previewMockupCanvasState", canvasState: JSON.stringify(updatedState) }));
      // if (productId) {
      //   localStorage.setItem(
      //     `pixiCanvasState_${productId}`,
      //     JSON.stringify(updatedState)
      //   );
      // } else {
      //   localStorage.setItem("pixiCanvasState", JSON.stringify(updatedState));
      // }
      dispatch(setFabricCanvasAsImage(canvasJSON));
    }
  };

  useEffect(() => {
    let timer;
    if (isOpen) {
      setShowEditOptions(false);
      setShowImages(false);
      timer = setTimeout(() => {
        setShowImages(true);
      }, timeoutDuration);
    } else {
      setShowEditOptions(false);
      setShowImages(false);
      timer = setTimeout(() => {
        setShowEditOptions(true);
        // setShowImages(true);
      }, timeoutDuration);
    }
    return () => clearTimeout(timer);
  }, [isOpen]);
  

  useEffect(() => {
    if (activeTab === "previewMockup") {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [activeTab]);



  const togglePanel = () => {
    if (isOpen) {
      setIsOpen(false);
      setTimeout(() => setShowEditOptions(true), timeoutDuration);
    } else {
      setIsOpen(true);
      setShowEditOptions(false);
      setTimeout(() => setShowImages(true), timeoutDuration);
    }
  };

  return (
    <div
    
      className="  relative top-0 transition-transform duration-300 h-[52px] "
    >
      {/* Panel */}
      <div
     id="rightpanel"
        className={`bg-white shadow-lg rounded-l-lg transition-transform duration-500 ${
          activeTab !== "previewMockup"
            ? isOpen
              ? "translate-x-0"
              : "translate-x-full"
            : isOpen
            ? ""
            : "hidden"
        } w-[265px] h-[609px]`}
      >
        {/* Header */}
        {activeTab !== "previewMockup" && (
          <>
            <div className="flex items-center justify-center pt-[16px] pb-[4px] ">
              <AlignmentControls
                fabricCanvas={fabricCanvas}
                saveCanvasState={saveCanvasState}
              />
            </div>

            <div className="h-[1px] w-full bg-gray-300  my-3" />
          </>
        )}

        {activeTab === "previewMockup" && (
          <>
            <div className="py-2">
              <span className="text-[14px] px-2 font-semibold font-montserrat">
              Warping
              </span>
              <div className="flex flex-row justify-start gap-2 text-black items-center px-2">
                <div className="flex items-center space-x-2">
                  <input
                    type="range"
                    value={wrap}
                    onChange={(e) => handleWrapChange(parseInt(e.target.value))}
                    style={{ background: wrapBackground }}
                    className="w-[150px] h-[11px] appearance-none bg-gray-300 rounded-sm range-slider"
                  />
                  <span className="flex justify-center items-center text-[12px] bg-[#ECEBEB] px-2 py-2 rounded w-[59px] h-[22px]">
                    {`${wrap}%`}
                  </span>
                </div>
                <button
                  className="py-1 rounded"
                  onClick={() => handleWrapChange(15)}
                >
                  <img
                    src={reset}
                    alt="reset Icon"
                    className="w-[13px] h-[13px]"
                  />
                </button>
              </div>
            </div>
          </>
        )}

        <div
          className={`mb-2 flex ${
            activeTab === "previewMockup"
              ? "flex-col items-start"
              : "items-center space-x-4"
          } px-2 py-1`}
        >
          <label className="block text-[14px] font-bold">Opacity</label>
          <div className="flex items-center justify-start space-x-2">
            <input
              type="range"
              value={opacity}
              onChange={(e) => handleChange("opacity", e)}
              style={{ background: sliderBackground }}
              className={`${
                activeTab === "previewMockup" ? "w-[150px]" : "w-[114px]"
              } h-[11px] appearance-none bg-gray-300 rounded-sm range-slider`}
            />

            <span className="flex justify-center items-center text-[12px] bg-[#ECEBEB] px-2 py-2 rounded w-[59px] h-[22px]">
              {`${opacity}%`}
            </span>
          </div>
        </div>

        {activeTab !== "previewMockup" && (
          <div className=" flex justify-between w-full items-center px-2 py-1">
            <label className="block text-[14px] font-bold">Color</label>
            <div className="">
              <div className="flex items-center justify-center space-x-2 px-1 h-[24px] text-sm bg-[#ECEBEB] rounded">
                <input
                  type="color"
                  value={color}
                  onChange={handleColorChange}
                  className="h-[22px] w-[25px] outline-none border-none bg-[#ECEBEB]"
                />
                <input
                  type="text"
                  value={color}
                  onChange={handleColorChange}
                  className="bg-[#ECEBEB] h-[24px] w-[55px] outline-none font-semibold leading-[9.75px] text-[10px] text-black"
                />
              </div>
              {/* <span className="text-sm bg-[#ECEBEB] px-2 py-1 rounded w-[59px] h-[22px]"></span> */}
            </div>
          </div>
        )}

        <div className="h-[1px] w-full bg-gray-300 my-3" />

        {/* {activeTab !== "previewMockup" && (
          <>
            <div className=" space-y-3 px-2">
              <div className="flex items-center justify-between">
                <label className="text-[14px] font-bold">Border</label>
                <button className="text-sm bg-[#ECEBEB] px-[10px] py-[2px] rounded shadow">
                  +
                </button>
              </div>
              <div className="flex items-center justify-between">
                <label className="text-[14px] font-bold">Drop Shadow</label>
                <button className="text-sm bg-[#ECEBEB] px-[10px] py-[2px]  rounded shadow">
                  +
                </button>
              </div>
            </div>
            <div className="h-[1px] w-full bg-gray-300 my-4" />
          </>
        )} */}

        <div>
          <label className="block text-[14px] font-bold mb-3 px-2">
            Position & Size
          </label>
          <div className="grid grid-cols-2 gap-2 px-2">
            <div className="flex items-center space-x-3 border bg-gray-100 rounded w-[102px] h-[28px]">
              <span className="font-semibold border-r-2 items-center border-gray-400 h-full w-[30px] leading-[14.63px] text-[12px] flex justify-center">
                X
              </span>
              <input
                type="number"
                className="bg-transparent border-none outline-none w-[50px]  text-[12px] leading-[12.19px] font-semibold  "
                value={Math.round(position.x)}
                onChange={(e) => handleChange("position", e, "x")}
              />
            </div>
            <div className="flex items-center space-x-3 border bg-gray-100 rounded w-[102px] h-[28px]">
              <span className="font-semibold border-r-2 items-center border-gray-400 h-full w-[30px] leading-[14.63px] text-[12px] flex justify-center">
                Y
              </span>
              <input
                type="number"
                className="bg-transparent border-none outline-none w-[50px]  text-[12px] leading-[12.19px] font-semibold  "
                value={Math.round(position.y)}
                onChange={(e) => handleChange("position", e, "y")}
              />
            </div>
            <div className="flex items-center space-x-3 border bg-gray-100 rounded w-[102px] h-[28px]">
              <span className="font-semibold border-r-2 items-center border-gray-400 h-full w-[30px] leading-[14.63px] text-[12px] flex justify-center">
                W
              </span>
              <input
                type="number"
                className="bg-transparent border-none outline-none w-[50px]  text-[12px] leading-[12.19px] font-semibold  "
                value={Math.round(size.width)}
                onChange={(e) => handleChange("size", e, "width")}
              />
            </div>
            <div className="flex items-center space-x-3 border bg-gray-100 rounded w-[102px] h-[28px]">
              <span className="font-semibold border-r-2 items-center border-gray-400 h-full w-[30px] leading-[14.63px] text-[12px] flex justify-center">
                H
              </span>
              <input
                type="number"
                className="bg-transparent border-none outline-none w-[50px]  text-[12px] leading-[12.19px] font-semibold  "
                value={Math.round(size.height)}
                onChange={(e) => handleChange("size", e, "height")}
              />
            </div>
            <div className="flex items-center space-x-3 border bg-gray-100 rounded w-[102px] h-[28px]">
              <span className="font-semibold border-r-2 items-center border-gray-400 h-full w-[30px] leading-[14.63px] text-[12px] flex justify-center">
                <img
                  src={rotate}
                  alt="Down Icon"
                  className="w-[18px] h-[18px]"
                />
              </span>
              <input
                type="number"
                className="bg-transparent border-none outline-none w-[50px]  text-[12px] leading-[12.19px] font-semibold  "
                value={Math.round(angle)}
                onChange={(e) => handleChange("angle", e)}
              />
            </div>
          </div>
          {/*{activeTab !== "previewMockup" && (*/}
          {/*  <div className="grid grid-cols-2 gap-2 px-2 mt-3">*/}
          {/*    <div className="flex items-center space-x-3 border bg-gray-100 rounded w-[102px] h-[28px]">*/}
          {/*      <span className="font-semibold border-r-2 items-center  border-gray-400 h-full  w-[30px]  leading-[14.63px] text-[12px] flex justify-center"></span>*/}

          {/*      <input*/}
          {/*        type="number"*/}
          {/*        className="bg-transparent border-none outline-none w-[50px]  text-[12px] leading-[12.19px] font-semibold  "*/}
          {/*      />*/}
          {/*    </div>*/}
          {/*    <div className="flex items-center space-x-3 border bg-gray-100 rounded w-[102px] h-[28px]">*/}
          {/*      <span className="font-semibold border-r-2 items-center  border-gray-400 h-full  w-[30px]  leading-[14.63px] text-[12px] flex justify-center"></span>*/}

          {/*      <input*/}
          {/*        type="number"*/}
          {/*        className="bg-transparent border-none outline-none w-[50px]  text-[12px] leading-[12.19px] font-semibold  "*/}
          {/*      />*/}
          {/*    </div>*/}
          {/*    <div className="flex items-center space-x-3 border bg-gray-100 rounded w-[102px] h-[28px]">*/}
          {/*      <span className="font-semibold border-r-2 items-center  border-gray-400 h-full  w-[30px]  leading-[14.63px] text-[12px] flex justify-center"></span>*/}

          {/*      <input*/}
          {/*        type="number"*/}
          {/*        className="bg-transparent border-none outline-none w-[50px]  text-[12px] leading-[12.19px] font-semibold  "*/}
          {/*      />*/}
          {/*    </div>*/}
          {/*    <div className="flex items-center space-x-3 border bg-gray-100 rounded w-[102px] h-[28px]">*/}
          {/*      <span className="font-semibold border-r-2 items-center  border-gray-400 h-full  w-[30px]  leading-[14.63px] text-[12px] flex justify-center"></span>*/}

          {/*      <input*/}
          {/*        type="number"*/}
          {/*        className="bg-transparent border-none outline-none w-[50px]  text-[12px] leading-[12.19px] font-semibold  "*/}
          {/*      />*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*)}*/}
        </div>
      </div>
      {activeTab !== "previewMockup" && (
        <div>
          <button onClick={togglePanel}>
            {isOpen
              ? showImages && (
                  <div className="absolute top-[255px] left-[-16px]">
                    <img src={vector} alt="vector Icon" />
                    <img
                      src={vclose}
                      alt="vclose Icon"
                      className="absolute top-[30px] left-[8px] w-[6px]"
                    />
                  </div>
                )
              : showEditOptions && (
                  <div className="flex items-center absolute right-0 top-[210px]   ">
                    <img
                      src={closevector}
                      alt="closevector Icon"
                      className="relative"
                    />
                    <div className="text-[11px] font-bold tracking-[1px] leading-[12.19px] text-[#D42929] transform rotate-[270deg] text-left whitespace-nowrap absolute top-[87px] left-[-6px]">
                      Edit options
                    </div>
                  </div>
                )}
          </button>
        </div>
      )}
    </div>
  );
};

export default RightPanel;
